<template>
  <div id="app" class="background">
    <!-- <img alt="Vue logo" src="./assets/aed.png"> -->
    <HelloWorld/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  /*margin-top: 40px;*/
}

.background {
  background: #eccac85c !important;
      height: 100vh;
    position: fixed;
    overflow-y: scroll;
}
</style>
